import { useState, FormEvent } from 'react'
import styles from './QuoteForm.module.css'

interface QuoteFormProps {
  initialText?: string
  initialAuthor?: string
  onSubmit: (text: string, author?: string) => void
  onCancel: () => void
  submitLabel?: string
}

function QuoteForm({
  initialText = '',
  initialAuthor = '',
  onSubmit,
  onCancel,
  submitLabel = 'Save',
}: QuoteFormProps) {
  const [text, setText] = useState(initialText)
  const [author, setAuthor] = useState(initialAuthor)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    if (!text.trim()) {
      alert('Please enter a quote')
      return
    }

    onSubmit(text.trim(), author.trim() || undefined)

    // Reset form
    setText('')
    setAuthor('')
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.field}>
        <label htmlFor="quote-text" className={styles.label}>
          Quote <span className={styles.required}>*</span>
        </label>
        <textarea
          id="quote-text"
          className={styles.textarea}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Enter your motivational quote..."
          rows={4}
          required
        />
      </div>

      <div className={styles.field}>
        <label htmlFor="quote-author" className={styles.label}>
          Author <span className={styles.optional}>(optional)</span>
        </label>
        <input
          id="quote-author"
          type="text"
          className={styles.input}
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          placeholder="e.g., Steve Jobs"
        />
      </div>

      <div className={styles.actions}>
        <button type="button" className={styles.cancelButton} onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className={styles.submitButton}>
          {submitLabel}
        </button>
      </div>
    </form>
  )
}

export default QuoteForm
